<template>
  <button
    modifier="large--quiet"
    ripple="true"
    :class="['btn', actionType]"
    :disabled="isDisabled"
    @click="handleClick"
  >
    <i v-if="icon" :class="icon"></i> {{ label }}
    <img v-if="imgSrc" :src="imgSrc" alt="" />
  </button>
</template>

<script>
export default {
  name: "ItemButton",
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: String,
    isDisabled: {
      type: Boolean,
      default: false,
    },
    imgSrc: String,
    actionType: {
      validator(value) {
        return (
          ["btn-primary", "btn-submit", "btn-cancel", "disabled"].indexOf(
            value
          ) !== -1
        );
      },
      required: true,
    },
  },
  methods: {
    handleClick() {
      this.$emit("clicked");
    },
  },
};
</script>

<style lang="scss" scoped>
button[disabled] {
  background-color: #e9e9e9;
  color: #999999;
}

button {
  display: block;
  width: 100%;
  height: 45px;
  margin-bottom: 15px;
  border: none;
  border-radius: 30px;
  font-size: 14px;
  font-weight: bold;
  box-shadow: var(--defaultBoxShadow);
  background-repeat: no-repeat;
  background-position: calc(100% - 12px) center;
  background-size: 8px;
}

.btn-primary {
  background-color: #ffb206;
  color: #ffffff;
  background-image: url("~@/assets/img//arrow/svg/arow-right-white-24.svg");
}

.btn-primary[disabled] {
  background-color: #e9e9e9;
  color: #999999;
  background-image: url("~@/assets/img//arrow/svg/arow-right-gray-24.svg");
}

.btn-cancel {
  background-image: none;
  margin-top: 15px;
  background-color: #e0e0e0;
  color: black;
}

.btn-submit {
  background-image: none;
  background-color: #ffffff;
  color: black;
}
</style>
